import Engine from 'apollo-e/engine';

export default new Engine({
  canvasOptions: {
    fullScreen: true,
  },
  contextOptions: { antialias: true }
});
